import React from 'react';
import { XmlFormatter } from '../components/xml-formatter/XmlFormatter';
import '../components/xml-formatter/XmlFormatter.css';

export const XmlFormatterPage: React.FC = () => {
  return (
    <div className="page-container">
      <XmlFormatter />
    </div>
  );
};
